import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponsManagementTable from "../../components/CouponsManagement/CouponsManagementTable";
import CreateCoupons from "../../components/CouponsManagement/CreateCoupons";
import CustomersTable from "../../components/Customers/CustomersTable";




const CustomersPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Customers" />
                <CustomersTable/>

      



            </MasterLayout>
        </>
    );
};

export default CustomersPage;
